import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import useBrand from '@hooks/useBrand'

import PageHeader from '@components/PageHeader'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey?: string,
  children: ReactNode,
  brandPayload: ReturnType<typeof useBrand>,
}

const PageLayout = (props: PageLayoutProps) => {
  const {
    activeTabBarItemKey,
    brandPayload: {
      brand,
      urls: { brandsIndexUrl },
    },
    children,
  } = props

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Edit Brand | AIM Digital</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || brandsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        tabBarItems={generateTabBarItems(brand)}
        title="Edit Brand"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
